import {UI} from "../UIBase";
import {sanitizeUrlFromOptions} from "./Link";
import {type RemoveHandle} from "../../base/Dispatcher";

export class Image extends UI.Primitive("img")<{}, HTMLImageElement> {
    setOptions(options: this["options"]): void {
        return super.setOptions(sanitizeUrlFromOptions(options, "src"));
    }

    addLoadListener(callback: EventListener): RemoveHandle {
        return this.addNodeListener("load", callback);
    }
}
